var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNotification = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.51367V11.3987",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0247 2.33301C9.73135 2.33301 6.25468 5.80967 6.25468 10.103V12.553C6.25468 13.3463 5.92801 14.5363 5.51968 15.213L4.03801 17.6863C3.12801 19.2147 3.75801 20.918 5.43801 21.478C11.0147 23.333 17.0463 23.333 22.623 21.478C24.198 20.953 24.8747 19.1097 24.023 17.6863L22.5413 15.213C22.133 14.5363 21.8063 13.3347 21.8063 12.553V10.103C21.7947 5.83301 18.2947 2.33301 14.0247 2.33301Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8833 21.957C17.8833 24.092 16.1333 25.842 13.9983 25.842C12.9366 25.842 11.9566 25.3987 11.2566 24.6987C10.5566 23.9987 10.1133 23.0187 10.1133 21.957",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notification.57c5f533.svg";
export { ForwardRef as ReactComponent };